var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#41BA8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.5C20.375 12.5 12.5 20.375 12.5 30C12.5 39.625 20.375 47.5 30 47.5C39.625 47.5 47.5 39.625 47.5 30C47.5 20.375 39.625 12.5 30 12.5ZM26.5 38.75L17.75 30L20.2175 27.5325L26.5 33.7975L39.7825 20.515L42.25 23L26.5 38.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.56a1ab090cf235339a1cffcbd02b7c25.svg";
export { ForwardRef as ReactComponent };